module.exports = __webpack_public_path__ + "img/gywm@2x.177691d7.jpg";